<template>
  <div class="password-reset-view">
    <div class="md-layout md-alignment-top">
      <div class="left-side md-layout-item md-medium-size-50 md-small-size-100">
        <md-content>
          <div class="content-container">
            <h1 class="padded">Reset your password</h1>
            <p class="padded">
              You can choose an entirely new password for your account.
            </p>
            <div v-if="!validated && !error">
                <md-progress-spinner
                  v-if="loading"
                  :md-diameter="40"
                  :md-stroke="3.5"
                  md-mode="indeterminate"
                />
                <h2>Validating Reset Token</h2>
                <p>
                  Give us a minute, we are checking whether the password reset token is valid.
                </p>
            </div>
            <div v-if="!validated && error">
                <h2>Oops! Something went wrong :-(</h2>
                <p>
                  The provided password reset token doesn't seem to be valid.
                </p>
                <error-container :error="error"></error-container>
                <br>
                <router-link to="/login">Take me back</router-link>
            </div>
            <div v-if="validated">
              <password-reset-form/>
            </div>
          </div>
        </md-content>
      </div>
      <div class="right-side md-layout-item md-medium-size-50 md-small-hide">
        <img src="/static/login-picture-01.jpg" alt="A Team Working Together." rel="preload">
      </div>
    </div>
  </div>
</template>

<script>
import ErrorContainer from '../ErrorContainer'
import ErrorFactory from '../../models/ErrorFactory'
import PasswordResetForm from '../forms/PasswordResetForm.vue'

export default {
  name: 'PasswordReset',
  mounted () {
    this.validateToken()
  },
  components: {
    ErrorContainer,
    PasswordResetForm
  },
  data () {
    return {
      validated: false,
      loading: false,
      message: '',
      errorFactory: new ErrorFactory(),
      error: null
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    axios () {
      return this.$store.getters['axios']
    },
    base_url () {
      return this.$store.getters['base_url']
    }
  },
  methods: {
    async validateToken () {
      this.loading = true
      this.error = null
      try {
        await this.axios.get(this.base_url + '/users/reset/' + this.token)

        this.validated = true
      } catch (error) {
        this.error = this.errorFactory.make(error.response.data, 'Password resest token verification failed!')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.left-side,
.right-side {
  height: 100vh;
}
.left-side .md-content {
  height: 100%;
  width: 100%;
  background-color: white;
  position: relative;
}
.right-side img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}
.content-container {
  width: 360px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
}
.content-container,
.padded {
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/PasswordReset.vue